export default [
	function () {
		return {
			restrict: 'A',
			link: function (scope, elem) {
				const ONLY_DIGITS_REGEXP = new RegExp(/^[0-9]*$/g);
				const KEY_CODES = {
					BACKSPACE: 8,
					TAB: 9,
					DELETE: 46,
					ENTER: 13,
					ESCAPE: 27,
					END: 35,
					DOWN_ARROW: 40,
					F1: 112,
					F12: 123,
					NUMBER_0: 48,
					NUMBER_9: 57,
					NUMPAD_0: 96,
					NUMPAD_9: 105,
					MACBOOK_0: 192
				};

				function onlyNumbersOrFunctionalKeys(e) {
					const charCode = e.which ? e.which : e.keyCode;
					const isFunctionalKeys = [KEY_CODES.BACKSPACE, KEY_CODES.TAB, KEY_CODES.DELETE, KEY_CODES.ENTER, KEY_CODES.ESCAPE].indexOf(charCode) !== -1 || e.ctrlKey === true || e.altKey === true || (charCode >= KEY_CODES.END && charCode <= KEY_CODES.DOWN_ARROW) || (charCode >= KEY_CODES.F1 && charCode <= KEY_CODES.F12);
					const isNumberKey = (e.shiftKey === false && charCode >= KEY_CODES.NUMBER_0 && charCode <= KEY_CODES.NUMBER_9) || (charCode >= KEY_CODES.NUMPAD_0 && charCode <= KEY_CODES.NUMPAD_9) || charCode === KEY_CODES.MACBOOK_0;

					if (isNumberKey || isFunctionalKeys) {
						return true;
					}

					e.preventDefault();
					return false;
				}

				function copyPasteEvent(e) {
					const pasteText = (e.clipboardData || window.clipboardData).getData('Text');

					if (pasteText.match(ONLY_DIGITS_REGEXP)) {
						return true;
					}

					e.preventDefault();
					return false;
				}

				elem[0].addEventListener('keydown', onlyNumbersOrFunctionalKeys);
				elem[0].addEventListener('paste', copyPasteEvent);
			}
		};
	}
];
